import { HttpClient } from '@adapters/HttpClient';

// Modelo de Rate embebido
export interface RateItem {
    id: number;
    name: string;
    price: number;
    // Añadir más campos según sea necesario
}

export interface Rate {
    id: number;
    name: string;
    is_active: boolean;
    notes: string | null;
    items: RateItem[];
}

// Modelo de usuario que aplicó la tarifa
export interface RateAssignmentUser {
    id: number;
    name: string;
}

// Modelo de asignación de tarifa
export interface RateAssignment {
    id: number;
    team_id: number;
    rate_id: number;
    user_id: number;
    status: 'active' | 'inactive' | 'pending' | 'scheduled' | 'ended';
    change_type: 'upgrade' | 'downgrade' | 'initial' | 'renewal' | 'mass_migration' | 'correction';
    effective_from: string;
    effective_to: string | null;
    applied_at: string | null;
    reason: string | null;
    rate: Rate;
    user: RateAssignmentUser;
}

// Request para cambiar tarifa
export interface ChangeRateRequest {
    team_id: number;
    rate_id: number;
    change_type: 'upgrade' | 'downgrade' | 'correction';
    requires_contract: boolean;
    docusing_template_id?: string;
    reason?: string;
}

export class ClientRateAssignmentsApiAdapter {
    constructor(private httpClient: HttpClient) {}

    async getRateAssignments(teamId: number): Promise<RateAssignment[]> {
        const response = await this.httpClient.get<RateAssignment[]>(
            `/teams-child/${teamId}/rate-assignments`
        );
        return response;
    }

    async changeRate(request: ChangeRateRequest): Promise<void> {
        await this.httpClient.post('/teams-child/change-rates', request);
    }
}
